var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"msg",staticClass:"edit_div",attrs:{"contenteditable":_vm.canEdit},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"input":_vm.changeText,"blur":_vm.blurFun,"focus":function($event){_vm.isLocked = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }